<div class="columns is-multiline pl-2 pr-2">
  <!-- Total count -->
  <div class="column is-one-quarter">
    <app-claim-overview-statistics-metric [metricTitle]="'statistics.totalClaims' | localize" [metricValue]="statistics.total"/>
  </div>

  <!-- completed count -->
  <div class="column is-one-quarter">
    <app-claim-overview-statistics-metric [metricTitle]="'statistics.completed' | localize" [metricValue]="statistics.completed"/>
  </div>

  <!-- underReview count -->
  <div class="column is-one-quarter">
    <app-claim-overview-statistics-metric [metricTitle]="'statistics.underReview' | localize" [metricValue]="statistics.under_review"/>
  </div>

  <!-- rejected count -->
  <div class="column is-one-quarter">
    <app-claim-overview-statistics-metric [metricTitle]="'statistics.rejected' | localize" [metricValue]="statistics.rejected"/>
  </div>

</div>
